<!--
This component is designed to splay the provided rendered 'pages' of the example card in the start pages
-->

<template>
  <v-lazy
    class="relative hover-pop-group clickable"
    :class="'n-' + pages.length"
    style="aspect-ratio: 1.5;"
    transition=""
  >
    <component
      v-for="page, i in pages"
      :is="to ? 'router-link' : 'div'"
      :key="i"
      class="page"
      :class="rotations[i]"
      :to="to"
    >
      <template v-if="page.mp4">
        <picture v-if="IS_IOS_SAFARI">
          <source type="video/mp4" :srcset="page.mp4">
          <img type="image/webp" :src="page.webp" :alt="getAlt(i)">
        </picture>
        <video
          v-else
          playsinline autoplay muted loop type="video/mp4"
          :aria-label="getAlt(i)"
          :src="page.mp4"
        />
      </template>
      <img
        v-else
        :type="'image/' + (page.webp ? 'webp' : 'jpeg')"
        :src="page.webp ? page.webp : page.jpg"
        :alt="getAlt(i)"
      />
    </component>
  </v-lazy>
</template>

<style scoped>
.page {
  position: absolute;
  aspect-ratio: 5 / 7;
  width: 47.6%;
  background-color: #FFF;
}


img, video {
  display: block;
  width: 100%;
  max-width: 100%;
}

.n-1 .page { z-index: 1; left: 26.2%; }

.n-2 .page:nth-child(1) { z-index: 2; left: 13%; }
.n-2 .page:nth-child(2) { z-index: 1; right: 13%; }

.n-3 .page:nth-child(1) { z-index: 3; left: 2%; }
.n-3 .page:nth-child(2) { z-index: 2; left: 26.2%; }
.n-3 .page:nth-child(3) { z-index: 1; right: 2%; }
</style>

<script>
const ROTATIONS = [ [ '' ], [ 'rn4', 'r4' ], [ 'rn5', '', 'r5' ] ];

export default {
  name: 'start-preview',

  props: [ 'to', 'alt', 'pages' ],

  computed: {
    rotations() {
      return ROTATIONS[ this.pages.length - 1 ];
    }
  },

  methods: {
    getAlt(i) {
      return (this.alt ? (this.alt + ' s') : 'S') + 'ample card page ' + (i + 1);
    }
  }
}
</script>
